import React from 'react'
import { StatusDetran } from '../models/Models'
import { ReactComponent as CheckMark } from '../../assets/icons/check-mark.svg'
import { ReactComponent as HourGlass } from '../../assets/icons/hour-glass.svg'
import { ReactComponent as XMark } from '../../assets/icons/x-mark.svg'

export const StatusDetranIcon = ({ status }: { status?: StatusDetran }) => {
  switch (status) {
    case 'CONFIRMADO':
      return <CheckMark width="18px" fill="green" />
    case 'AGUARDANDO':
      return <HourGlass width="18px" fill="#f8d302" />
  }
  return <XMark width="18px" fill="red" />
}
